module.exports = __webpack_public_path__ + "static/media/8.4fae8a09.jpg";